import React from "react";
import { Box, List, ListItem, Typography } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faGraduationCap,
  faChalkboardTeacher,
  faBookOpen,
  faComment,
  faRightFromBracket,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { useMediaQuery } from "@mui/material";
import color from "../../components/utils/Colors";

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const isSmallScreen = useMediaQuery("(max-width:1050px)");

  const menuItems = [
    {
      text: "Home",
      path: `/home-admin`,
      icon: <FontAwesomeIcon icon={faHouse} />,
    },
    {
      text: "Students",
      path: `/students-admin`,
      icon: <FontAwesomeIcon icon={faGraduationCap} />,
    },
    // {
    //   text: "Skills Popularity",
    //   path: `/groups/photos`,
    //   icon: <FontAwesomeIcon icon={faPersonChalkboard} />,
    // },
    // {
    //   text: "Statistics",
    //   path: `/groups/members`,
    //   icon: <FontAwesomeIcon icon={faChartColumn} />,
    // },
    {
      text: "Teachers",
      path: `/teacher-admin`,
      icon: <FontAwesomeIcon icon={faChalkboardTeacher} />,
      number: "10",
    },
    {
      text: "Courses",
      path: `/courses-admin`,
      icon: <FontAwesomeIcon icon={faBookOpen} />,
      number: "10",
    },
    {
      text: "Feedback",
      path: `/feedback-admin`,
      icon: <FontAwesomeIcon icon={faComment} />,
      number: "10",
    },
    {
      text: "Billing",
      path: `/billing-admin`,
      icon: <FontAwesomeIcon icon={faWallet} />,
      number: "10",
    },
  ];

  return (
    <Box
      sx={{
        width: isSmallScreen ? "100%" : "200px",
        boxShadow: "1px 1px 25px #00000020",
        paddingTop:isSmallScreen ? "5%" : "2%",
        paddingBottom: isSmallScreen ? "5%" : "2%",
        marginBottom: isSmallScreen ? "5%" : "0%",
        background: "white",
        fontSize: "14px",
        borderRadius: "10px",
      }}
    >
      <List
        sx={{
          display: "flex",
          flexDirection: isSmallScreen ? "row" : "column",
          flexWrap: isSmallScreen ? "wrap" : "nowrap",
          padding: 0,
          margin: 0,
        }}
      >
        <Typography
          sx={{
            color: color.textColor,
            fontWeight: "bold",
            textAlign: "center",
            mb: 3,
            width:'100%',
            fontSize: "20px",
          }}
        >
          Admin Dashboard
        </Typography>
        {menuItems.map(({ text, path, icon, number }) => (
          <NavLink
            key={text}
            to={path}
            style={({ isActive }) => ({
              textDecoration: "none",
              color: isActive ? color.secondColor : color.firstColor,
              display: "flex",
              alignItems: "center",
              width: isSmallScreen ? "auto" : "100%",
              flexGrow: isSmallScreen ? 1 : 0,
              whiteSpace: "nowrap",
              //   borderBottom: "solid 2px #b365b67b",
              borderRadius: "18px",
              paddingLeft: "15px",
              //   boxShadow: "0px 4px 15px #00000010",
            })}
          >
            <ListItem
              button
              id={
                location.pathname === path
                  ? isSmallScreen ? "menu-item-list-2-g" : "menu-item-list-1-g"
                  : "menu-item-list-g"
              }
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                my: 0.5,
                flexWrap: "nowrap",
                width: isSmallScreen ? "fit-content" : "100%",
                // marginRight: "10px",
                fontSize: "10px",
                color: color.firstColor,
              }}
            >
              {icon && (
                <Box sx={{ marginRight: "12px", fontSize: "18px" }}>{icon}</Box>
              )}
              <Typography sx={{ fontSize: "14.5px", fontWeight: "bold" }}>
                {text}
              </Typography>
              {number && (
                <Typography
                  sx={{
                    marginLeft: "8px",
                    // border: "solid 2px #b365b6",
                    background: "red",
                    color: "white",
                    width: "fit-content",
                    fontSize: "10px",
                    fontWeight: "bold",
                    borderRadius: "100px",
                    p: "1.5px 3.5px 0.5px 2px",
                  }}
                >
                  {number}
                </Typography>
              )}
            </ListItem>
          </NavLink>
        ))}

        <ListItem
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            display: "flex",
            gap: "10px",
            background: color.firstColor,
            color:'white',
            borderRadius:'18px',
            justifyContent: "center",
            mt:isSmallScreen ? 2:6,
            width:'fit-content',
            mx:2,
            px:4,
          }}
        >
          {" "}
          <FontAwesomeIcon icon={faRightFromBracket} />
          Sign&nbsp;out
        </ListItem>
      </List>
    </Box>
  );
};

export default AdminSidebar;
